import { render, staticRenderFns } from "./Staff.vue?vue&type=template&id=6a057ad3&scoped=true"
import script from "./Staff.vue?vue&type=script&lang=js"
export * from "./Staff.vue?vue&type=script&lang=js"
import style0 from "./Staff.vue?vue&type=style&index=0&id=6a057ad3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a057ad3",
  null
  
)

/* custom blocks */
import block0 from "./Staff.vue?vue&type=custom&index=0&blockType=link&href=https%3A%2F%2Fcdn.jsdelivr.net%2Fnpm%2Fvuetify%402.2.28%2Fdist%2Fvuetify.min.css"
if (typeof block0 === 'function') block0(component)

export default component.exports